import { Component, OnInit, model, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdvertisingService } from '../services/advertising.service';
import { AdvertisingFormComponent } from '../advertising-form/advertising-form.component';
import { AccessService } from '../../core/services/access.service';
import { Advertising } from '../models/advertising.model';
import { AdvertisingInterface } from '../interfaces/advertising.interface';

@Component({
  selector: 'app-advertising-details',
  standalone: true,
  imports: [AdvertisingFormComponent],
  templateUrl: './advertising-details.component.html',
  styleUrl: './advertising-details.component.css',
})
export class AdvertisingDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private service = inject(AdvertisingService);

  protected access = inject(AccessService).access;
  protected id!: string | null;

  value = model<Advertising>();
  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Detalles de la Pantalla');
    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.service.get(params.get('id')).subscribe((data) => {
        this.value.update((value) => {
          value = new Advertising(data.data as AdvertisingInterface);
          return value;
        });
      });
    });
  }
}
